import React, { useState } from 'react';
import { Layout, Typography, Card, Row, Col, Button, Tabs } from 'antd';
import { FaCertificate } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const certifications = {
    "AI & Machine Learning": [
        { name: "TensorFlow Developer Certificate", provider: "Google", website: "https://www.tensorflow.org/certificate" },
        { name: "AWS Machine Learning Specialty", provider: "AWS", website: "https://aws.amazon.com/certification/certified-machine-learning-specialty/" }
    ],
    "Cybersecurity": [
        { name: "Certified Ethical Hacker (CEH)", provider: "EC-Council", website: "https://www.eccouncil.org/programs/certified-ethical-hacker-ceh/" },
        { name: "CompTIA Security+", provider: "CompTIA", website: "https://www.comptia.org/certifications/security" }
    ],
    "Data Science": [
        { name: "IBM Data Science Professional Certificate", provider: "IBM", website: "https://www.coursera.org/professional-certificates/ibm-data-science" },
        { name: "Google Data Analytics Certificate", provider: "Google", website: "https://grow.google/certificates/data-analytics/" }
    ]
};

function GetCertified() {
    const [currentTab, setCurrentTab] = useState("AI & Machine Learning");

    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}><FaCertificate /> Get Certified</Title>
                <Paragraph>
                    Boost your career with industry-recognized certifications in AI, Cybersecurity, and Data Science. Choose a certification track below and start learning today.
                </Paragraph>
                <Tabs defaultActiveKey="AI & Machine Learning" onChange={setCurrentTab}>
                    {Object.keys(certifications).map(category => (
                        <TabPane tab={<strong>{category}</strong>} key={category}>
                            <Row gutter={[16, 16]}>
                                {certifications[category].map((cert, index) => (
                                    <Col xs={24} sm={12} md={8} key={index}>
                                        <Card hoverable>
                                            <Title level={4}>{cert.name}</Title>
                                            <Paragraph><strong>Provider:</strong> {cert.provider}</Paragraph>
                                            <Button type="primary" href={cert.website} target="_blank">Learn More</Button>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </TabPane>
                    ))}
                </Tabs>
            </Content>
        </Layout>
    );
}

export default GetCertified;
